import {
  GetOtpBalanceResponseSchema,
  type GetOtpBalanceResponse,
  TopUpResponseSchema,
  type TopUpResponse,
  UpdateNotificationContactsResponseSchema,
  type UpdateNotificationContactsResponse,
  type NotificationContact,
} from "@codway-dev/shared";
import { AuthService } from "./auth.service";

const API_BASE_URL = "/api";

async function authedFetch(
  path: string,
  init?: RequestInit
): Promise<Response> {
  const token = await AuthService.getShopifyToken();
  if (!token) throw new Error("No Shopify token available");
  return fetch(`${API_BASE_URL}${path}`, {
    ...init,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      ...init?.headers,
    },
  });
}

async function parseErrorMessage(res: Response): Promise<string> {
  const body = await res.json().catch(() => ({}));
  const error = (body as { error?: { message?: string } | string }).error;
  if (typeof error === "string") return error;
  return error?.message ?? res.statusText;
}

export const OtpBalanceService = {
  getBalance: async (): Promise<GetOtpBalanceResponse> => {
    const res = await authedFetch("/admin/otp-balance");
    if (!res.ok)
      throw new Error(
        `Failed to load OTP balance: ${await parseErrorMessage(res)}`
      );
    return GetOtpBalanceResponseSchema.parse(await res.json());
  },

  topup: async (
    package_id: string,
    return_url: string
  ): Promise<TopUpResponse> => {
    const res = await authedFetch("/admin/otp-balance/topup", {
      method: "POST",
      body: JSON.stringify({ package_id, return_url }),
    });
    if (!res.ok)
      throw new Error(
        `Failed to initiate purchase: ${await parseErrorMessage(res)}`
      );
    return TopUpResponseSchema.parse(await res.json());
  },

  updateNotificationContacts: async (
    contacts: NotificationContact[]
  ): Promise<UpdateNotificationContactsResponse> => {
    const res = await authedFetch("/admin/otp-balance/notification-contacts", {
      method: "PUT",
      body: JSON.stringify({ notification_contacts: contacts }),
    });
    if (!res.ok)
      throw new Error(
        `Failed to update notification contacts: ${await parseErrorMessage(res)}`
      );
    return UpdateNotificationContactsResponseSchema.parse(await res.json());
  },
};
